/**
 * Shared loader component used across all admin pages.
 * Renders a consistent blue spinner. Use fullPage for initial/data loading states.
 */
const Loader = ({ fullPage = false, className = "" }) => {
  const spinner = (
    <div
      className={`h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500 ${className}`}
      role="status"
      aria-label="Loading"
    />
  );

  if (fullPage) {
    return (
      <div className="flex min-h-[200px] items-center justify-center py-10">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default Loader;
